var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ethers } from "ethers";
import React, { useContext } from "react";
import { getNodeURI } from "../utils/env";
var defaultProvider = ethers.getDefaultProvider(getNodeURI());
export var Web3Context = React.createContext({
    provider: defaultProvider,
});
export var useWeb3Context = function () { return useContext(Web3Context); };
export var Web3ContextProvider = function (_a) {
    var children = _a.children;
    return (_jsx(Web3Context.Provider, __assign({ value: { provider: defaultProvider } }, { children: children }), void 0));
};
//# sourceMappingURL=web3Context.js.map